// nonce attribute for webpack to allow CPS load inline style  
__webpack_nonce__ = window.cspInlineStyle;